import { Box, Button, Grid, Modal, Tooltip } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import Utility from '../../app/utility';
import { MarketInfoType } from '../MarketInfo/models/MarketInfoQueryModel';
import { FixturePreviewSelector, setShowPreviewPanel } from './reducers/FixturePreviewReducer';
import CommissionItemModel from './components/FixtureCommissionDetail/models/CommissionItemModel';
import { SupportSheetSelector, setHandoverAttachment } from '../SupportSheet/reducers/SupportSheetReducer';
import FixtureApi from './api/FixtureApi';
import BaseResponse from '../../app/BaseResponse';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';

const FixturePreview: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const fixturePreviewViewData = useSelector(FixturePreviewSelector);
    const inputFileRef = React.useRef<HTMLInputElement>(null);
    const supportSheetData = useSelector(SupportSheetSelector);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "60%",
        bgcolor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        maxHeight: "calc(100% - 100px)",
        overflow: "auto"
    };

    return (
        <>
            <Modal
                open={fixturePreviewViewData.showPreviewPanel}
                onClose={() => {
                    dispatch(setShowPreviewPanel(false));
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>

                    <Grid container>
                        <Grid item xs={3}>
                            <h3>Handover detail</h3>
                        </Grid>
                        <Grid item xs={9}>
                            <Tooltip title="Download Email Attachment">
                                <Button
                                    className='handover-button'
                                    disabled={supportSheetData.currentFixture && (!supportSheetData.currentFixture.handoverAttachment || supportSheetData.currentFixture.handoverAttachment.length == 0)}
                                    onClick={() => {
                                        let url = "/api/Fixture/Download?id=" + fixturePreviewViewData.model.id;

                                        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                                        if (newWindow) newWindow.opener = null
                                    }}
                                >
                                    <i className="fa fa-download" aria-hidden="true"></i>
                                </Button>
                            </Tooltip>
                            <Tooltip title="Upload Email Attachment">
                                <Button
                                    className='handover-button'
                                    onClick={() => {
                                        inputFileRef.current?.click();
                                    }}
                                >
                                    <i className="fa fa-upload" aria-hidden="true"></i>
                                </Button>
                            </Tooltip>
                            <input
                                type='file'
                                ref={inputFileRef}
                                hidden
                                onChange={() => {
                                    const files = inputFileRef.current?.files;
                                    // make sure that it's not null or undefined
                                    if (files) {
                                        let formData = new FormData();
                                        formData.append("file", files[0]);
                                        formData.append("fixtureId", supportSheetData.currentFixture.id);

                                        dispatch(showLoading(true));
                                        FixtureApi.AttachHandoverEmail(formData)
                                            .then((response: BaseResponse<string>) => {
                                                if (response.success) {
                                                    Utility.Alert.Success("Upload succesfully");
                                                    dispatch(showLoading(false));
                                                    dispatch(setHandoverAttachment(response.data))
                                                } else {
                                                    dispatch(showLoading(false));
                                                    Utility.Alert.Error(response.message);
                                                }
                                            })
                                            .catch((error) => {
                                                dispatch(showLoading(false));
                                                Utility.Alert.Error(error);
                                            });
                                    }
                                }}>
                            </input>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={2}>
                            <b>Handover by</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.supportName}
                        </Grid>
                        <Grid item xs={2}>
                            <b>Ref</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.ref}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={2}>
                            <b>Office</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.office}
                        </Grid>
                        <Grid item xs={2}>
                            <b>Biz Type</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.bizType}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={2}>
                            <b>Cp Date</b>
                        </Grid>
                        <Grid item xs={4}>
                            {Utility.DateFormat.formatDateString(fixturePreviewViewData.model.cpDate)}
                        </Grid>
                        <Grid item xs={2}>
                            <b>Tonnage Vessel Name</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.tonnageVesselName}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={2}>
                            <b>Owner</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.ownerCompanyName}
                        </Grid>
                        <Grid item xs={2}>
                            <b>Owner Broker</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.ownerBrokerName}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={2}>
                            <b>Charterer</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.chartererCompanyName}
                        </Grid>
                        <Grid item xs={2}>
                            <b>Charterer Broker</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.chartererBrokerName}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={2}>
                            <b>{fixturePreviewViewData.model.bizType == MarketInfoType.Voy ? "Quantity" : "Duration"}</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.quantityOrDuration}
                        </Grid>
                        <Grid item xs={2}>
                            <b>Rate</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.rate}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={2}>
                            <b>Eva Volume</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.evaVolume}
                        </Grid>
                        <Grid item xs={2}>
                            <b>Eva Volume</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.evaComplex}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={2}>
                            <b>Collect From</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.collectFromCompanyName}
                        </Grid>
                        <Grid item xs={2}>
                            <b>Estd Comm</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.estdComm}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={2}>
                            <b>Co-broker comm</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.privateCommRemark}
                        </Grid>
                        <Grid item xs={2}>
                            <b>Remarks</b>
                        </Grid>
                        <Grid item xs={4}>
                            {fixturePreviewViewData.model.remarks}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={2}>
                            <b>Comm Rate Detail</b>
                        </Grid>
                        <Grid item xs={4}>
                            <ul>
                                {
                                    fixturePreviewViewData.model.commRateDetail &&
                                    (JSON.parse(fixturePreviewViewData.model.commRateDetail) as CommissionItemModel[]).map((item: CommissionItemModel) => {
                                        return <li>{item.brokerName}: {item.percent}%</li>
                                    })
                                }
                            </ul>
                        </Grid>
                        <Grid item xs={2}>
                        </Grid>
                        <Grid item xs={4}>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    )
};

export default FixturePreview;